import { type Move } from '../../../../modules/moves'
import { residenceHasRooms } from '../../../../modules/quotes'
import { keyValueMapToRecord, recordToKeyValueMap } from '../../../../common/keyValueMap'
import { type MoveContentFormOutput, type MoveContentFormValues } from './MoveContentForm.type'

const removeZeroValues = <T extends Record<string, number>>(values: T): T => {
  return Object.fromEntries(
    Object.entries(values)
      .map(([key, value]) => ([key, parseInt(String(value))]))
      .filter(([, value]) => {
        return !!value
      }),
  ) as T
}

export const moveToFormData = (move: Move): MoveContentFormValues => {
  const residenceRooms = move.request.residence.residenceRooms ? keyValueMapToRecord(move.request.residence.residenceRooms) : []
  const specialItems = move.request.content.specialItems ? keyValueMapToRecord(move.request.content.specialItems) : []

  return {
    request: {
      residence: {
        residenceType: move.request.residence.residenceType,
        residenceRooms,
        residenceRoomsTotal: residenceRooms.length,
      },
      content: {
        nbBoxes: move.request.content.nbBoxes ?? 0,
        furnitureRatio: move.request.content.furnitureRatio ?? 0,
        specialItems,
        specialItemsTotal: specialItems.length,
      },
    },
  }
}

export const formatFormOutput = (values: MoveContentFormValues): MoveContentFormOutput => {
  const hasFurniture = (values.request.content.furnitureRatio ?? 0) > 0
  const hasRooms = residenceHasRooms(values.request.residence.residenceType)
  const requiresRooms = hasRooms && hasFurniture

  return {
    request: {
      residence: {
        residenceType: values.request.residence.residenceType,
        residenceRooms: values.request.residence.residenceRooms && requiresRooms
          ? recordToKeyValueMap(removeZeroValues(values.request.residence.residenceRooms))
          : null,
      },
      content: {
        nbBoxes: values.request.content.nbBoxes,
        furnitureRatio: values.request.content.furnitureRatio,
        specialItems: values.request.content.specialItems ? recordToKeyValueMap(removeZeroValues(values.request.content.specialItems)) : null,
      },
    },
  }
}
